import { useState } from "react";
import styles from '../../../../styles/detailproject.module.scss';
import iconProject from '../../../../assets/icon_project.svg';
import iconPlusInactive from '../../../../assets/icon_plus-inactive.svg';
// import iconArrowDown from '../../../../assets/icon_arrowDown.svg';
import ModalSectionCreate from "../../ModalSectionCreate";
import { useI18n } from "../../../../../i18n/useI18n";
import { IFormData } from "@/api/tasks/types";
import { ISection } from "@/api/projects/types";
import { AddTask } from "../Task/AddTask";

export interface OptionsDetailBoardListProps {
  handleListBoard: (value: string) => void;
  projectName: string;
  filter: string;
  changeFilter: (filter: string) => void;
  listBoard: string;
  idproject: string;
  newTask: (form: IFormData) => void;
  // loadTasks: (filter: string) => void;
  sections: ISection[];
  handleCreateNewTask: () => void;
}

export const OptionsDetailBoardList = ({
  handleListBoard,
  projectName,
  // filter,
  // changeFilter,
  idproject,
  newTask,
  // loadTasks,
  sections,
  handleCreateNewTask,
  listBoard,
}: OptionsDetailBoardListProps) => {
  const [task, setTask] = useState(false);
  const { t } = useI18n();

  const addNewTask = async (form: IFormData) => {
    if (form.title && form.title.length > 0) {
      form.projectId = idproject;
      if (idproject) {
        // Esperar el resultado de newTask y retornarlo
        const result = await newTask(form);
        setTask(!task);
        return result;
      } else {
        console.error("idproject is undefined");
        setTask(!task);
        return undefined;
      }
    }
    return undefined;
  };

  const closeAddTask = () => {
    setTask(!task);
  }

  return (
    <div className={styles["optionDetails"]}>
      <div className={styles["optionDetails__item"]}>
        <img
          className={styles["optionDetails__icon"]}
          src={iconProject}
          alt="icon proyecto"
          width={138.8}
          height={"auto"}
        />
        <div className={styles["optionDetails__text"]}>
          <h1 className={styles["optionDetails__text_title"]}>{projectName}</h1>
          <p className={styles["optionDetails__text_p"]}>
            {t("module_projects.detail_view_last_visit")}: hoy
          </p>
        </div>
      </div>
      <div className={styles["optionDetails__item"] + " " + styles["optionDetails__item_options"]}>
        <div className={styles["optionDetails__options"]}>
          <div className={styles["optionDetails__options_item"]}>
            <input
              className={styles["optionDetails__options_input"]}
              id="lista"
              type="radio"
              checked={listBoard === 'list'}
              onChange={() => handleListBoard("list")}
            />
            <label className={styles["optionDetails__options_label"]} htmlFor="lista">
              {t("module_projects.detail_view_mode_title_list")}
            </label>
          </div>
          <div className={styles["optionDetails__options_item"]}>
            <input
              className={styles["optionDetails__options_input"]}
              id="tablero"
              type="radio"
              checked={listBoard === 'board'}
              onChange={() => handleListBoard("board")}
            />
            <label className={styles["optionDetails__options_label"]} htmlFor="tablero">
              {t("module_projects.detail_view_mode_title_board")}
            </label>
          </div>
        </div>
        <div className={styles["optionDetails__addTask__container"]}>
          <button
            className={styles["optionDetails__addTask"]}
            onClick={handleCreateNewTask}
          >
            <img
              className={styles["optionDetails__addTask_img"]}
              src={iconPlusInactive}
              alt="icon plus inactive"
            />
            <span className={styles["optionDetails__addTask_text"]}>
              {t("tasks_module.modal_create_task_button")}
            </span>
          </button>
          <ModalSectionCreate idproject={idproject} />
        </div>
      </div>
      <div className={styles["optionDetails__item"] + " " + styles["optionDetails__item_sort"]}>
        {/* <div className={styles["optionDetails__sort"]}>
          <img
            src={iconArrowDown}
            className={styles["optionDetails__sort_img"]}
            alt="icon arrow down"
          />
          <p className={styles["optionDetails__sort_text"]}>
            {t("home_page.all_task_title")}
          </p>
        </div> */}
        {/* <div className={styles["optionDetails__sort"]}>
          <img
            src={iconArrowDown}
            className={styles["optionDetails__sort_img"]}
            alt="icon arrow down"
          />
          <p className={styles["optionDetails__sort_text"]}>
            {t("module_projects.detail_view_sort")}
          </p>
        </div>
        <div className={styles["optionDetails__sort"]}>
          <img
            src={iconArrowDown}
            className={styles["optionDetails__sort_img"]}
            alt="icon arrow down"
          />
          <p className={styles["optionDetails__sort_text"]}>
            {t("module_projects.detail_view_customize")}
          </p>
        </div> */}
      </div>
      {task && <AddTask addNewTask={addNewTask} closeAddTask={closeAddTask} sections={sections} />}
    </div>
  );
};
